import { BaccaratSimplyRoadmap } from '@/models/games/baccarat';
import { getEmptyRoadMap } from '@/models/Roadmap';
import { getHostsSelectors, hostsSliceActions } from '@/modules/host/slice';
import { lobbySliceActions } from '@/modules/lobby/slice';
import { getMainUserState } from '@/modules/main/selector';
import { roadmapSliceActions } from '@/modules/roadmap/slice';
import { TotalBet, totalBetsSliceActions } from '@/modules/totalBet/slice';
import { RootState } from '@/store/store';
import { Epic } from 'redux-observable';
import { concat, filter, switchMap } from 'rxjs';
import { SupportedGameType } from './roadmapEpic';

export const hostListEpic: Epic = (action$, store$) =>
    action$.pipe(
        filter(hostsSliceActions.setAll.match),
        switchMap(action => {
            console.log(`update ${action.payload} order`);
            const outs = [];
            const state = store$.value as unknown as RootState;
            const hosts = getHostsSelectors.selectAll(state);
            const { FeatureOrder } = getMainUserState(state);
            const hallGameTypeMap = hosts
                .sort((a, b) => {
                    let orderA = 10000;
                    let orderB = 10000;
                    if (a.IsTest) {
                        orderA = 20000;
                    }
                    if (b.IsTest) {
                        orderB = 20000;
                    }
                    if (FeatureOrder) {
                        if (FeatureOrder.indexOf(a.GameType) >= 0) {
                            orderA += FeatureOrder.indexOf(a.GameType) * 100;
                        }
                        if (FeatureOrder.indexOf(b.GameType) >= 0) {
                            orderB += FeatureOrder.indexOf(b.GameType) * 100;
                        }
                    }
                    return a.OrderBy + orderA - (b.OrderBy + orderB);
                })
                .map(h => ({
                    hostId: h.HostId,
                    hallId: h.HallId,
                    gameType: h.GameType,
                }));

            const roadmaps = hallGameTypeMap
                .filter(h => (SupportedGameType & h.gameType) > 0)
                .map(h => getEmptyRoadMap<BaccaratSimplyRoadmap>(h.hostId));
            const totalBets = hallGameTypeMap.map(
                h =>
                    ({
                        HostId: h.hostId,
                        TotalBet: {},
                    }) as TotalBet
            );
            outs.push(roadmapSliceActions.updateAll(roadmaps));
            outs.push(totalBetsSliceActions.updateAll(totalBets));
            outs.push(lobbySliceActions.updateHallGameTypeMap(hallGameTypeMap));
            return concat(outs);
        })
    );
